import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringArrayToCommaListNoConjunction',
  standalone: true,
})
export class StringArrayToCommaListNoConjunctionPipe implements PipeTransform {
  transform(
    value: string[],
    truncateListLength?: number,
    includeSpace: boolean = true,
    uniqueOnly: boolean = true
  ): string {
    const splitInput = includeSpace
      ? ', '
      : ',';

    let relevantInputs = uniqueOnly
      ? [...new Set(value)]
      : value;

    // Filter out any empty strings
    relevantInputs = relevantInputs.filter((str) => str !== '');

    // if the array is undefined or empty, return an empty string
    if (!relevantInputs || relevantInputs.length === 0) {
      return '';
    }

    // if the array is one-item long
    if (relevantInputs.length === 1) {
      return relevantInputs[0].toString();
    }

    // if we want to truncate the list
    return truncateListLength
      ? relevantInputs.slice(0, truncateListLength).join(splitInput)
      : relevantInputs.join(splitInput);
  }
}
